import { useMemo } from "react";
import type { Employee, EmployeeRole } from "@/types";

interface EmployeeStatsProps {
  employees: Employee[];
}

const countByRoles = (employees: Employee[], roles: EmployeeRole[]): number =>
  employees.filter((item) => roles.includes(item.role)).length;

export default function EmployeeStats({ employees }: EmployeeStatsProps) {
  const stats = useMemo(
    () => ({
      total: employees.length,
      cashiers: countByRoles(employees, ["cashier"]),
      supervisors: countByRoles(employees, [
        "shiftSupervisor",
        "operationsOfficer",
        "branchManager",
        "generalSupervisor",
      ]),
      suspended: employees.filter((item) => item.status === "suspended").length,
    }),
    [employees],
  );

  const cards = [
    {
      label: "إجمالي الموظفين",
      value: stats.total,
      icon: "ri-team-line",
      tone: "bg-primary-100 text-primary-700",
    },
    {
      label: "موظفو الكاشير",
      value: stats.cashiers,
      icon: "ri-shopping-cart-2-line",
      tone: "bg-secondary-200 text-secondary-800",
    },
    {
      label: "المشرفون والمديرون",
      value: stats.supervisors,
      icon: "ri-user-star-line",
      tone: "bg-accent-100 text-accent-800",
    },
    {
      label: "الحسابات الموقوفة",
      value: stats.suspended,
      icon: "ri-pause-circle-line",
      tone: "bg-red-100 text-red-600",
    },
  ];

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-4">
      {cards.map((card) => (
        <div
          key={card.label}
          className="yc-fade-up yc-card-hover bg-white rounded-card border border-background-200 shadow-card p-5"
        >
          <div className="flex items-center gap-2 text-foreground-500">
            <span
              className={`w-7 h-7 flex items-center justify-center rounded-full ${card.tone}`}
            >
              <i className={card.icon}></i>
            </span>
            <span className="text-xs">{card.label}</span>
          </div>
          <p className="mt-3 text-2xl font-bold text-foreground-950">
            {card.value}
          </p>
        </div>
      ))}
    </div>
  );
}